import { api } from '@/api/client';

export function getProjectFilesQueryOptions(projectId: string) {
  return {
    queryKey: ['projectFiles', projectId] as const,
    queryFn: () => api.projectFiles.list(projectId),
    staleTime: 60_000,
  };
}
